import type { StatusTone } from '@shared/design-system/ui'
import type { CoproductionStatus } from '@entities/partnership'

const tones: Record<CoproductionStatus, StatusTone> = {
  PENDENTE: 'awaiting',
  ATIVO: 'success',
  REMOVIDO: 'closed',
}

export function coproductionStatusTone(status: CoproductionStatus): StatusTone {
  return tones[status]
}
